import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {
  allowedImageFormats,
  fetchUniqueQrText,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { UserProfileService } from '../../../../profile/user-profile/user-profile.service';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { CheckpointService } from '../checkpoint.service';

@Component({
  selector: 'gtapp-generate-qr',
  templateUrl: './generate-qr.component.html',
  styleUrl: './generate-qr.component.scss',
  standalone: false,
})
export class GenerateQrComponent implements OnInit {
  @ViewChild('qrGenerateTemplateRef') qrGenerateTemplateRef: any;
  qrCodeList: any = [];
  dialogref: any;

  // currently, this can be either 32x32 or 72x63.5
  selectedQrSize: number = 35;
  qrDefaultCount: number = 35;

  qrCountOptions: any = [35, 70];

  //qr checkpoints params

  qrCPList: any = [];
  qrCpFilterValue: string = '';
  qrCpCursor: string = '';

  qrCpTotalCount: number = 0;
  cpLookupTimeOutFn: any;

  selectedQrCheckpoints: any = [];

  includeLogo: number = 0;
  companyLogoPresent: boolean = false;
  constructor(
    private dialogService: ModalDialogueService,
    private checkpointService: CheckpointService,
    private spinnerService: LoadingSpinnerService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private profileService: UserProfileService,
    private appService: AppService,
  ) {}

  ngOnInit(): void {
    this.getCheckpointsCount();
    this.getQRCheckpoints();
    this.getCompanyDetails();
  }
  qrSizeChanged(size: any) {
    this.selectedQrSize = Number(size);
    this.changeCountOptions();
  }
  changeCountOptions() {
    switch (this.selectedQrSize) {
      case 35:
        this.qrCountOptions = [35, 70];
        this.qrDefaultCount = 35;
        break;
      case 12:
        this.qrCountOptions = [12, 24, 36];
        this.qrDefaultCount = 12;
        break;
    }
  }

  addCheckpointCount() {
    let subscriberStats = JSON.parse(
      localStorage.getItem('subscriberStats') || '{}',
    );
    subscriberStats.checkpoint_count =
      (subscriberStats?.checkpoint_count || 0) + 1;
    localStorage.setItem('subscriberStats', JSON.stringify(subscriberStats));
  }

  downloadQRCodes() {
    this.spinnerService.show();
    this.checkpointService
      .downloadQRCodes(
        {
          data: this.qrCodeList,
        },
        {
          qr_size: Number(this.selectedQrSize),
          include_logo: this.includeLogo,
        },
      )
      .subscribe((response) => {
        this.spinnerService.hide();
        this.selectedQrCheckpoints = [];
        this.qrCPList = [];
        this.qrCodeList = [];
        this.selectedQrSize = 35;
        this.changeCountOptions();
        this.getQRCheckpoints();
        if (response?.message)
          this.toasterService.setMessage({
            successMessage: response?.message,
            errorMessage: '',
          });
      });
  }

  generateNQRcodes() {
    this.spinnerService.show();
    this.dialogref.close();
    this.qrCodeList = [];
    for (let i = 0; i < this.qrDefaultCount; i++) {
      this.qrCodeList.push({ qr_code: fetchUniqueQrText() });
    }
    this.spinnerService.hide();
  }
  openTemplate(template: any) {
    this.qrCodeList = [];
    this.dialogref = this.dialogService.open(
      template,
      {
        data: { currentStep: 1 },
      },
      this.viewContainerRef,
    );
  }

  removeSelectedCP(deleteCheckpoint: any) {
    this.selectedQrCheckpoints = this.selectedQrCheckpoints?.filter(
      (checkpoint: any) => checkpoint?.id !== deleteCheckpoint?.id,
    );
  }
  addSelectedCP(addCheckpoint: any) {
    if (
      this.selectedQrCheckpoints.some(
        (checkpoint: any) => checkpoint?.id === addCheckpoint?.id,
      )
    ) {
      this.toasterService.setMessage({
        errorMessage: 'Checkpoint Already Selected',
        successMessage: '',
      });
    } else {
      this.selectedQrCheckpoints.push(addCheckpoint);
    }
  }
  addRemoveCheckpoint(checkpoint: any) {
    checkpoint.selected = !checkpoint?.selected;
    if (checkpoint.selected) {
      this.addSelectedCP(checkpoint);
    } else {
      this.removeSelectedCP(checkpoint);
    }
  }
  selectAllCheckpoints(event: any) {
    this.selectedQrCheckpoints = [];
    const checked = event.target.checked;
    if (checked) {
      this.selectedQrCheckpoints = [...this.qrCPList];
    }
    this.qrCPList?.forEach(
      (checkpoint: any) => (checkpoint.selected = checked),
    );
  }
  filterQRCheckpoints() {
    if (this.qrCpFilterValue?.length === 0) {
      this.qrCPList = [];
      this.getQRCheckpoints();
    } else if (this.qrCpFilterValue?.length > 3) {
      if (this.cpLookupTimeOutFn) clearTimeout(this.cpLookupTimeOutFn);

      if ([5, 10, 15, 20, 25, 30, 35].includes(this.qrCpFilterValue?.length)) {
        this.qrCPList = [];
        this.getQRCheckpoints();
      } else {
        this.cpLookupTimeOutFn = setTimeout(() => {
          this.qrCPList = [];
          this.getQRCheckpoints();
        }, 1000);
      }
    }
  }
  getCheckpointsCount() {
    let params: any = { get_count: 1, is_qr: 1 };

    this.checkpointService
      .listCheckpointData(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.qrCpTotalCount = response?.cp_count;
        }
      });
  }
  getQRCheckpoints() {
    let params: any = { is_qr: 1, cursor_based_pagination: 1, rows: 10 };

    if (this.qrCpFilterValue) {
      params['search_str'] = this.qrCpFilterValue;
    }
    if (this.qrCpCursor) {
      params['next_cursor'] = this.qrCpCursor;
    }

    this.checkpointService
      .listCheckpointData(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();

          this.qrCPList = [...this.qrCPList, ...response?.data];
          this.qrCpCursor = response?.next_cursor;
          this.makeSelectionChanges();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  onLoadMoreCheckpoints() {
    this.spinnerService.show();

    this.getQRCheckpoints();
  }
  makeSelectionChanges() {
    this.qrCPList.forEach((checkpoint: any) => {
      checkpoint.selected = this.selectedQrCheckpoints?.some(
        (selectedCp: any) => selectedCp?.id === checkpoint?.id,
      );
    });
  }

  generateExistingQRCodes() {
    this.spinnerService.show();
    this.dialogref.close();
    this.qrCodeList = [];
    for (let i = 0; i < this.selectedQrCheckpoints?.length; i++) {
      this.qrCodeList.push({
        qr_code: this.selectedQrCheckpoints[i]?.qr_code || fetchUniqueQrText(),
        name: this.selectedQrCheckpoints[i]?.name,
      });
    }
    this.spinnerService.hide();
  }
  getCompanyDetails() {
    this.profileService.fetchCompanyDetails().subscribe((res: any) => {
      if (res['status'] === 'success') {
        this.companyLogoPresent = Boolean(res?.data?.logo_url);
        if (this.companyLogoPresent) this.includeLogo = 1;
      } else {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: res['message'],
        });
      }
    });
  }
  openCamPopup() {
    var button: any = document.getElementById('fileInput');
    button.click();
  }
  async fileCheck(fileExtension: string, fileSize: number): Promise<string> {
    if (!allowedImageFormats.includes(fileExtension?.toLowerCase())) {
      return 'Unsupported file format';
    } else if (fileSize / (1024 * 1024) > 2) {
      return 'File Too Large';
    } else {
      return '';
    }
  }
  async handleFileInput(item: any) {
    let file = item.files.item(0);
    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    let fileCheckError = await this.fileCheck(fileExtension, fileSize);
    if (fileCheckError) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: fileCheckError,
      });
    } else {
      this.onFileSubmit(item.files.item(0));
    }
  }
  onFileSubmit(file: any) {
    if (file) {
      this.spinnerService.show();
      let fileData: FormData = new FormData();
      fileData.append('file', file);

      this.appService
        .formDataApi('company_profile', fileData, false, { change_logo: 1 })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.companyLogoPresent = Boolean(response?.data?.logo_url);
            if (this.companyLogoPresent) this.includeLogo = 1;
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
          this.spinnerService.hide();
        });
    }
  }
}
